import { Contract } from '@/types/contract.types';
import { UserResponseDto } from '@clearbanc/baus-sdk';

export const isBillContractPending = (
  contract: Contract,
  signatory?: UserResponseDto,
): boolean => {
  const contractSignerIsSignatory =
    !!signatory && !!contract.signers?.userSigners[signatory.id];

  return (
    !contract.userSignedAt && !contract.isHidden && contractSignerIsSignatory
  );
};
